import { Modal, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { CloseIcon } from '../../assets/icons';
import { verifyPin } from '../../services/AccountApi/profileApi';
import { addCounter, addUserData } from '../../store/reducer/accountSlice';
import { NOTIFICATION_MESSAGES, PIN_VERIFICATION_TYPES } from '../../utils/constant';
import { removeCookie } from '../../utils/cookies';
import { toastNotify } from '../../utils/toastNotify';
import OTPInput from '../OTPInput';

const PinModalWithoutButton = (props) => {
  const {
    onCancel,
    open,
    pin,
    setPin,
    loading,
    setLoading,
    handleForgotPin,
    onSuccess,
    isRoute = false,
    pinVerificationType = PIN_VERIFICATION_TYPES.MARKET_PLACE,
  } = props;

  const dispatch = useDispatch();

  const [countDown, setCountDown] = useState(0);
  const [seconds, setSeconds] = useState(300);
  const [wrongPinCount, setWrongPinCount] = useState(0);
  const [disabledPinInput, setDisabledPinInput] = useState(false);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  let intervalId;
  let downloadTimer;
  const timerCounter = (timerValue = 30) => {
    let timeleft = timerValue;
    downloadTimer = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
        setDisabledPinInput(false);
        localStorage.setItem('wrongOtpCount', 3);
        setCountDown(0);
      } else {
        if (timeleft < 10) {
          timeleft = 0 + '' + timeleft;
        }
        setCountDown(timeleft);
      }
      timeleft -= 1;
    }, 1000);
  };

  const fiveMinTimeCounter = () => {
    intervalId = setInterval(() => {
      //   setDisabledCheckbox(true);
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          setWrongPinCount(4);
          localStorage.setItem('wrongOtpCount', 4);
          setDisabledPinInput(false);
          //   setDisabledCheckbox(false);
          clearInterval(intervalId); // Stop the timer when it reaches zero
          // You can add additional logic here when the countdown reaches zero
        }
        return prevSeconds - 1;
      });
    }, 1000);
  };

  const handleVerifyPin = async (value) => {
    setPin(value);
    if (value.length === 4) {
      setLoading(true);
      let formData = {
        pin: value,
        pinVerificationType,
      };
      try {
        const response = await verifyPin(formData);
        if (!response.isError) {
          dispatch(
            addUserData({
              userData: {
                ...response?.data?.user,
              },
            })
          );
          dispatch(addCounter(response?.data?.counter));

          const isDwollaVerified = response?.data?.user?.isDwollaVerified ?? false;
          if (!isDwollaVerified && pinVerificationType === PIN_VERIFICATION_TYPES.MARKET_PLACE) {
            toastNotify('error', NOTIFICATION_MESSAGES.WARN_DWOLLA_PENDING);
            setPin('');
            onCancel();
            return;
          }

          const isTOSAccepted = response?.data?.user?.isTOSAccepted ?? false;
          onSuccess(isTOSAccepted);
          localStorage.removeItem('wrongOtpCount');
          setWrongPinCount(0);
        } else {
          if (response?.data?.data?.loginRetryAttempt === 1) {
            localStorage.setItem('wrongOtpCount', 0);
          }
          if (response?.data?.data?.loginRetryAttempt === 2) {
            localStorage.setItem('wrongOtpCount', 1);
          }
          if (response?.data?.data?.loginRetryAttempt === 3) {
            localStorage.setItem('wrongOtpCount', 2);
            setDisabledPinInput(true);
            timerCounter();
            localStorage.setItem('pinRetriesTimeCounter', new Date().getTime());
          }
          if (response?.data?.data?.loginRetryAttempt === 4) {
            localStorage.setItem('wrongOtpCount', 4);
            setDisabledPinInput(true);
            fiveMinTimeCounter();
            localStorage.setItem('pinRetriesTimeCounter', new Date().getTime());
          }
          if (response?.data?.data?.loginRetryAttempt === 5) {
            localStorage.clear();
            removeCookie();
            window.location.href = '/login';
          }
          setPin('');
          toastNotify('error', response?.message);
        }
      } catch (error) {
        if (error?.response?.data?.data?.loginRetryAttempt === 1) {
          localStorage.setItem('wrongOtpCount', 0);
        }
        if (error?.response?.data?.data?.loginRetryAttempt === 2) {
          localStorage.setItem('wrongOtpCount', 1);
        }
        if (error?.response?.data?.data?.loginRetryAttempt === 3) {
          localStorage.setItem('wrongOtpCount', 2);
          setDisabledPinInput(true);
          timerCounter();
          localStorage.setItem('pinRetriesTimeCounter', new Date().getTime());
        }
        if (error?.response?.data?.data?.loginRetryAttempt === 4) {
          localStorage.setItem('wrongOtpCount', 4);
          setDisabledPinInput(true);
          fiveMinTimeCounter();
          localStorage.setItem('pinRetriesTimeCounter', new Date().getTime());
        }
        if (error?.response?.data?.data?.loginRetryAttempt === 5) {
          localStorage.clear();
          removeCookie();
          window.location.href = '/login';
        }
        setPin('');
        const { response } = error;
        toastNotify('error', response?.data?.message);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    clearInterval(intervalId);
    if (localStorage.getItem('wrongOtpCount') === '2') {
      const currentTime = new Date().getTime();
      const tabClosingTime = localStorage.getItem('pinRetriesTimeCounter');
      if (tabClosingTime) {
        const differenceInSeconds = (currentTime - parseInt(tabClosingTime)) / 1000;
        if (differenceInSeconds < 30) {
          setDisabledPinInput(true);
          timerCounter(30 - parseInt(differenceInSeconds));
        }
      } else {
        setDisabledPinInput(true);
        timerCounter();
      }
    }
    if (localStorage.getItem('wrongOtpCount') === '3') {
      setWrongPinCount(3);
    }
    if (localStorage.getItem('wrongOtpCount') === '4') {
      const currentTime = new Date().getTime();
      const tabClosingTime = localStorage.getItem('pinRetriesTimeCounter');
      if (tabClosingTime) {
        const differenceInSeconds = (currentTime - parseInt(tabClosingTime)) / 1000;
        if (differenceInSeconds < 300) {
          setSeconds(300 - parseInt(differenceInSeconds));
          setDisabledPinInput(true);
          setWrongPinCount(3);
          fiveMinTimeCounter();
        }
      } else {
        setWrongPinCount(3);
        fiveMinTimeCounter();
        setDisabledPinInput(true);
      }
    }
    if (localStorage.getItem('wrongOtpCount') === '4') {
      setWrongPinCount(4);
    }
    return () => {
      clearInterval(downloadTimer);
    };
  }, []);
  return (
    <Modal
      className='pin quickbuy offcenter'
      open={open}
      onCancel={(value) => {
        clearInterval(intervalId);
        !isRoute && onCancel(value);
      }}
      width={524}
      closeIcon={!isRoute && <CloseIcon />}
      footer={false}
      closable={!isRoute}
    >
      <Spin spinning={loading}>
        <h4 className='text-center mb-16'>Enter your PIN</h4>
        <p className='text-taupe text-center mb-40 fz-16'>For your security, please enter your 4-digit PIN to continue.</p>
        <OTPInput
          length={4}
          otp={pin}
          onClearOtp={pin}
          onChangeOTP={handleVerifyPin}
          className='otp'
          autoFocus
          disabled={loading || disabledPinInput}
          inputClassName='otp__input mb-56'
        />
        {countDown > 0 && <div className='mb-10 fw-500 text-center'>You can retry after {countDown} seconds</div>}
        {seconds < 300 && seconds > 0 && (
          <div className='mb-10 fw-500 text-center'>
            You can retry after {minutes > 0 && `${minutes} minutes `}
            {remainingSeconds < 60 ? `${remainingSeconds} seconds` : `${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds} seconds`}
          </div>
        )}
        <div className='text-center mb-8'>
          <Link className='fw-600 text-terracotta underline' onClick={handleForgotPin}>
            I forgot my PIN
          </Link>
        </div>
      </Spin>
    </Modal>
  );
};

export default PinModalWithoutButton;
